import React, { Fragment, PureComponent } from 'react'

import { withStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'

import Item from './Item'
import styles from './styles'

class Brands extends PureComponent {
  renderItemsList = () => {
    const { connections, classes } = this.props
    return (
      <List className={classes.list}>
        {connections.map(brand => {
          return <Item key={brand.id} connection={brand} />
        })}
      </List>
    )
  }

  render() {
    const { renderItemsList } = this

    return <Fragment>{renderItemsList()}</Fragment>
  }
}

export default withStyles(styles)(Brands)



// WEBPACK FOOTER //
// ./src/components/listings/Page/Brands/index.js